export const SET_USER = "SET_USER";
export const SET_GAMES = "SET_GAMES";
export const SET_CURRENT_GAME = "SET_CURRENT_GAME";
export const SET_QUESTIONS = "SET_QUESTIONS";
export const SET_QUESTIONS_FILTERED = "SET_QUESTIONS_FILTERED";
export const SET_INPUT = "SET_INPUT";
export const CLEAR_TODOS = "CLEAR_TODOS";
